import * as React from "react"
import type { SVGProps } from "react"
const SvgHorizontalSpacing = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M3 20V4q0-.42.29-.71A1 1 0 0 1 4 3q.42 0 .71.29.3.29.29.71v16q0 .42-.29.71A1 1 0 0 1 4 21a1 1 0 0 1-.71-.29A1 1 0 0 1 3 20m16 0V4q0-.42.29-.71A1 1 0 0 1 20 3q.42 0 .71.29.3.29.29.71v16q0 .42-.29.71A1 1 0 0 1 20 21a1 1 0 0 1-.71-.29A1 1 0 0 1 19 20m-7-7a1 1 0 0 1-.71-.29A1 1 0 0 1 11 12q0-.42.29-.71A1 1 0 0 1 12 11a.97.97 0 0 1 1 1q0 .42-.29.71A1 1 0 0 1 12 13m-4 0a1 1 0 0 1-.71-.29A1 1 0 0 1 7 12q0-.42.29-.71A1 1 0 0 1 8 11a.97.97 0 0 1 1 1q0 .42-.29.71A1 1 0 0 1 8 13m8 0a1 1 0 0 1-.71-.29A1 1 0 0 1 15 12q0-.42.29-.71A1 1 0 0 1 16 11q.42 0 .71.29.3.29.29.71c-.01.42-.1.52-.29.71A1 1 0 0 1 16 13" />
  </svg>
)
export default SvgHorizontalSpacing
